module.exports = __webpack_public_path__ + "static/media/p-victor-th.e93f8dc6.jpg";